export const USER_INTERFACE_ACCESS_GUARD_CONTEXT_KEY =
  "UserInterfaceAccessGuardContextKey";
